import {useContext} from 'react';

import ChatbotContext from '../../contexts/ChatbotContext';

const useChatbot = () => {
  return useContext(ChatbotContext);
};

export default useChatbot;
